import { ReactNode } from 'react';
import styled from 'styled-components';
import { Flex } from '@elementary/common-ui/components';

const Wrapper = styled(Flex)<{ $padding?: string }>`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.palette.common.gray16};
  border-radius: 12px;
  padding: ${({ $padding }) => $padding ?? '24px'};
`;

type Props = {
  children?: ReactNode;
  padding?: string;
};

const Card = ({ children, padding }: Props) => (
  <Wrapper $padding={padding}>{children}</Wrapper>
);

export default Card;
